<template>
    <span class="checkedIcon"
        :style="`background-color: ${backgroundColor}; color: ${primaryColor}`" >
          ✓
    </span>
</template>

<script>

export default {
  name: 'CheckedIcon',
  props: {
      primaryColor: String,
      backgroundColor: String
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.checkedIcon {
    width: 22px;
    height: 22px;
    color: currentColor;
    border-radius: 100px;
}

</style>